import { takeEvery } from "redux-saga/effects";
import trackRequests from "rdx/utils/trackRequests";

import types from "rdx/modules/enterpriseLeads/types";

import getEnterpriseLeads from "./getEnterpriseLeads";
// IMPORT_PT (for script, do not remove)

function* watchEnterpriseLeadsSagas() {
  yield trackRequests(takeEvery, types.GET_ENTERPRISE_LEADS_REQUEST, getEnterpriseLeads);
  // INSERTION_PT (for script, do not remove)
}

export default watchEnterpriseLeadsSagas;
